// Клиент API модуля «Видеопоток».
//
// Пока бэкенд не готов, этот модуль ЭМУЛИРУЕТ контракт из «Постановка_Бэкенд»:
//   GET /api/video-streams/meta      → списки фильтров + границы дат
//   GET /api/video-streams/dashboard → { summary, breakdowns, items[] } (самодостаточный ответ)
// Серверная фильтрация (date_kind/date_from/date_to/source_name/address/location) выполняется
// здесь же. Когда появится реальный бэкенд — замените тела getMeta/getDashboard на fetch(),
// сохранив форму ответа; остальной фронтенд менять не потребуется.

// ── Демо-набор записей (форма items[] контракта). ──────────────────────────────
// video.available=false ⇒ video.url=null и video.file_name=null (АС1 UC.12.01).
// video.url в демо указывает на публичный тестовый ролик, чтобы работал сам плеер;
// реальный бэкенд отдаёт защищённый URL с поддержкой Range (перемотка).
const SAMPLE =
  "https://test-videos.co.uk/vids/bigbuckbunny/mp4/h264/360/Big_Buck_Bunny_360_10s_1MB.mp4";

const withFile = (id) => ({
  available: true,
  url: SAMPLE,
  file_name: `stream-${String(id).padStart(2, "0")}.mp4`,
  mime_type: "video/mp4",
  duration_sec: 21,
});
const noFile = {
  available: false,
  url: null,
  file_name: null,
  mime_type: null,
  duration_sec: null,
};

const STREAMS = [
  {
    id: 1,
    source_name: { ru: "Обзорная камера", kk: "Шолу камерасы" },
    address: { ru: "ул. Сатпаева, 12", kk: "Сәтпаев к-сі, 12" },
    location: { ru: "Центральная площадь", kk: "Орталық алаң" },
    plan_date: "2025-03-31",
    fact_date: "2025-03-24",
    video: withFile(1),
  },
  {
    id: 2,
    source_name: { ru: "Купольная камера PTZ", kk: "PTZ күмбез камерасы" },
    address: { ru: "ул. Сатпаева, 12", kk: "Сәтпаев к-сі, 12" },
    location: { ru: "Центральная площадь", kk: "Орталық алаң" },
    plan_date: "2025-03-31",
    fact_date: "2025-04-18",
    video: withFile(2),
  },
  {
    id: 3,
    source_name: { ru: "Обзорная камера", kk: "Шолу камерасы" },
    address: { ru: "ул. Абая, 45", kk: "Абай к-сі, 45" },
    location: { ru: "Здание акимата района", kk: "Аудан әкімдігінің ғимараты" },
    plan_date: "2025-06-30",
    fact_date: "2025-06-12",
    video: withFile(3),
  },
  {
    id: 4,
    source_name: { ru: "Камера распознавания ГРНЗ", kk: "МТН тану камерасы" },
    address: {
      ru: "трасса Атырау–Кульсары, 12 км",
      kk: "Атырау–Құлсары тас жолы, 12 км",
    },
    location: { ru: "Южный въезд в город", kk: "Қалаға оңтүстік кіреберіс" },
    plan_date: "2025-06-30",
    fact_date: "2025-07-15",
    video: withFile(4),
  },
  {
    id: 5,
    source_name: {
      ru: "Камера фиксации нарушений ПДД",
      kk: "ЖҚЕ бұзушылықтарын тіркеу камерасы",
    },
    address: {
      ru: "трасса Атырау–Кульсары, 12 км",
      kk: "Атырау–Құлсары тас жолы, 12 км",
    },
    location: { ru: "Южный въезд в город", kk: "Қалаға оңтүстік кіреберіс" },
    plan_date: "2025-09-30",
    fact_date: "2025-09-26",
    video: withFile(5),
  },
  {
    id: 6,
    source_name: { ru: "Обзорная камера", kk: "Шолу камерасы" },
    address: { ru: "мкр. Береке, 3", kk: "Береке ы/а, 3" },
    location: { ru: "Рынок «Береке»", kk: "«Береке» базары" },
    plan_date: "2025-09-30",
    fact_date: "2025-10-08",
    video: withFile(6),
  },
  {
    id: 7,
    source_name: { ru: "Купольная камера PTZ", kk: "PTZ күмбез камерасы" },
    address: { ru: "мкр. Береке, 3", kk: "Береке ы/а, 3" },
    location: { ru: "Рынок «Береке»", kk: "«Береке» базары" },
    plan_date: "2025-12-31",
    fact_date: null,
    video: noFile,
  },
  {
    id: 8,
    source_name: { ru: "Обзорная камера", kk: "Шолу камерасы" },
    address: { ru: "пр. Достык, 8", kk: "Достық д-лы, 8" },
    location: { ru: "Городской парк", kk: "Қалалық саябақ" },
    plan_date: "2025-12-31",
    fact_date: "2025-12-19",
    video: withFile(8),
  },
  {
    id: 9,
    source_name: {
      ru: "Камера фиксации нарушений ПДД",
      kk: "ЖҚЕ бұзушылықтарын тіркеу камерасы",
    },
    address: { ru: "пр. Достык, 8", kk: "Достық д-лы, 8" },
    location: { ru: "Городской парк", kk: "Қалалық саябақ" },
    plan_date: null,
    fact_date: "2026-01-23",
    video: withFile(9),
  },
  {
    id: 10,
    source_name: { ru: "Обзорная камера", kk: "Шолу камерасы" },
    address: { ru: "ул. Жамбыла, 21", kk: "Жамбыл к-сі, 21" },
    location: { ru: "Автовокзал", kk: "Автовокзал" },
    plan_date: "2026-03-31",
    fact_date: "2026-03-11",
    video: withFile(10),
  },
  {
    id: 11,
    source_name: { ru: "Камера распознавания ГРНЗ", kk: "МТН тану камерасы" },
    address: { ru: "ул. Жамбыла, 21", kk: "Жамбыл к-сі, 21" },
    location: { ru: "Автовокзал", kk: "Автовокзал" },
    plan_date: "2026-03-31",
    fact_date: null,
    video: withFile(11),
  },
  {
    id: 12,
    source_name: { ru: "Купольная камера PTZ", kk: "PTZ күмбез камерасы" },
    address: { ru: "ул. Абая, 45", kk: "Абай к-сі, 45" },
    location: { ru: "Стадион", kk: "Стадион" },
    plan_date: "2026-06-30",
    fact_date: "2026-06-05",
    video: withFile(12),
  },
  {
    id: 13,
    source_name: { ru: "Обзорная камера", kk: "Шолу камерасы" },
    address: { ru: "ул. Абая, 45", kk: "Абай к-сі, 45" },
    location: { ru: "Школа №1", kk: "№1 мектеп" },
    plan_date: "2026-06-30",
    fact_date: null,
    video: withFile(13),
  },
  {
    id: 14,
    source_name: {
      ru: "Камера фиксации нарушений ПДД",
      kk: "ЖҚЕ бұзушылықтарын тіркеу камерасы",
    },
    address: { ru: "ул. Сатпаева, 12", kk: "Сәтпаев к-сі, 12" },
    location: { ru: "Школа №1", kk: "№1 мектеп" },
    plan_date: "2026-09-30",
    fact_date: null,
    video: noFile,
  },
];

const delay = (ms) => new Promise((r) => setTimeout(r, ms));

// Уникальные значения разреза (как {ru, kk}) по всему составу записей — для выпадающих
// списков фильтров. Списки строятся по /meta, а не по текущей выборке (5.3).
function uniqueField(field) {
  const seen = new Map();
  for (const s of STREAMS)
    if (!seen.has(s[field].ru)) seen.set(s[field].ru, s[field]);
  return [...seen.values()].sort((a, b) => a.ru.localeCompare(b.ru, "ru"));
}

export async function getMeta() {
  await delay(0);
  const bound = (kind) => {
    const ds = STREAMS.map((s) => (kind === "plan" ? s.plan_date : s.fact_date))
      .filter(Boolean)
      .sort();
    return ds.length
      ? { min: ds[0], max: ds[ds.length - 1] }
      : { min: null, max: null };
  };
  return {
    sources: uniqueField("source_name"),
    addresses: uniqueField("address"),
    locations: uniqueField("location"),
    date_bounds: { plan: bound("plan"), fact: bound("fact") },
  };
}

// Разрез (breakdown) по полю: {value_ru, value_kk, count, share_pct}, упорядочен по убыванию
// количества, при равенстве — по алфавиту (_ru). Клиент порядок не пересортировывает (5.9).
function breakdown(rows, field) {
  const m = new Map();
  for (const s of rows) {
    const k = s[field].ru;
    if (!m.has(k))
      m.set(k, { value_ru: s[field].ru, value_kk: s[field].kk, count: 0 });
    m.get(k).count += 1;
  }
  const total = rows.length;
  return [...m.values()]
    .sort(
      (a, b) => b.count - a.count || a.value_ru.localeCompare(b.value_ru, "ru")
    )
    .map((e) => ({ ...e, share_pct: total ? (e.count / total) * 100 : 0 }));
}

// GET /api/video-streams/dashboard. Параметры фильтра — стабильные ключи (_ru).
export async function getDashboard(params = {}) {
  await delay(0);
  const {
    date_kind = "plan",
    date_from = "",
    date_to = "",
    source_name = "",
    address = "",
    location = "",
  } = params;

  const rows = STREAMS.filter((s) => {
    const d = date_kind === "plan" ? s.plan_date : s.fact_date;
    if (date_from || date_to) {
      if (!d) return false; // пустая дата не сопоставима с диапазоном
      if (date_from && d < date_from) return false;
      if (date_to && d > date_to) return false;
    }
    if (source_name && s.source_name.ru !== source_name) return false;
    if (address && s.address.ru !== address) return false;
    if (location && s.location.ru !== location) return false;
    return true;
  });

  // Порядок items[] задаётся бэкендом: source_name, затем address, затем id (5.2).
  const items = rows
    .slice()
    .sort(
      (a, b) =>
        a.source_name.ru.localeCompare(b.source_name.ru, "ru") ||
        a.address.ru.localeCompare(b.address.ru, "ru") ||
        a.id - b.id
    );

  const uniq = (field) => new Set(items.map((s) => s[field].ru)).size;
  const withFileCount = items.filter((s) => s.video.available).length;

  const summary = {
    total: items.length,
    sources_count: uniq("source_name"),
    addresses_count: uniq("address"),
    locations_count: uniq("location"),
    with_file: withFileCount,
    without_file: items.length - withFileCount,
  };

  return {
    summary,
    breakdowns: {
      by_source: breakdown(items, "source_name"),
      by_address: breakdown(items, "address"),
      by_location: breakdown(items, "location"),
    },
    items,
  };
}
